import { StaffRole } from 'src/graphql/generated';

export const isCompanyAdmin = (role?: StaffRole | null) =>
  role ? [StaffRole.Owner, StaffRole.Admin].includes(role) : false;

export const isCompanyOwner = (role?: StaffRole | null) => role === StaffRole.Owner;
